package eu.codlab.compose.theme

import androidx.compose.ui.graphics.Color

data class ColorTheme(
    val graySemiTransparent: Color
)
